export default __webpack_public_path__ + "static/media/marketplace-background.c5dd2ca2.svg";